import { render, staticRenderFns } from "./presentation-view-settings.vue?vue&type=template&id=69286002&scoped=true&"
import script from "./presentation-view-settings.vue?vue&type=script&lang=js&"
export * from "./presentation-view-settings.vue?vue&type=script&lang=js&"
import style0 from "./presentation-view-settings.vue?vue&type=style&index=0&id=69286002&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69286002",
  null
  
)

export default component.exports